export default __webpack_public_path__ + "static/media/dop.bc337a4b.svg";